import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: null,
	fetch: false,
	withdraw_status: "none",
};

const balanceSlice = createSlice({
	name: "balance",
	initialState,
	reducers: {
		drop: () => initialState,
		get: (state) => {
			state.fetch = true;
		},
		set: (state, action) => {
			state.data = action.payload;
			state.fetch = false;
		},
		withdrawReq: (state) => {
			state.withdraw_status = "request";
		},
		withdrawSuccess: (state) => {
			state.withdraw_status = "success";
		},
		withdrawErr: (state) => {
			state.withdraw_status = "error";
		},
	},
});

export const balanceActions = balanceSlice.actions;
export const balanceReducer = balanceSlice.reducer;
